// extracted by mini-css-extract-plugin
export default {"socials":"src-components-SocialLinks--socials","vk":"src-components-SocialLinks--vk","fb":"src-components-SocialLinks--fb"};